import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import React from 'react';

import { navigateTo } from 'flow/actions/navigate-actions';
import MenuItem from 'flow/components/ui-components/MenuItem';
import useAppContext from 'flow/hooks/useAppContext';
import { selectIsAdmin } from 'flow/selectors/own-extension-selectors';
import { QueueKey } from 'flow/types/EntityKeys';
import { addSupervisorLogEntry } from 'flow/utils/browser-utils';

interface Props {
    queueKey: QueueKey;
}
const SupervisorQueueContextMenu = ({ queueKey }: Props) => {
    const dispatch = useAppDispatch();
    const { i18next } = useAppContext();
    const isAdmin = useAppSelector(selectIsAdmin);

    const goToPbxMode = () => {
        dispatch(navigateTo(`/pbx/queues/${queueKey}/profiles`));
        addSupervisorLogEntry('Queue menu -> PBX mode clicked');
    };

    const goToMembers = () => {
        dispatch(navigateTo(`/pbx/queues/${queueKey}/settings/members`));
        addSupervisorLogEntry('Queue menu -> Members clicked');
    };

    return (
        <>
            {isAdmin ? (
                <MenuItem onClick={goToPbxMode}>
                    {i18next.t('pbx.pbxmode')}
                </MenuItem>
            ) : null}
            <MenuItem onClick={goToMembers}>
                {i18next.t('Queue.HandleMembers.Title')}
            </MenuItem>
        </>
    );
};

export default SupervisorQueueContextMenu;
